import en from './locales/en.json';
import vi from './locales/vi.json';
import ko from './locales/ko.json';

export default {
  legacy: false,
  globalInjection: true,
  messages: {
    en,
    vi,
    ko,
  },
};
